import { useState } from 'react';
import { Button, Fade, Modal, Paper, Stack, Typography, styled } from '@mui/material';
import { useConnectorToken } from '@api';
import { LocalInstallInstructions } from '@organisms/InstallConnectorWizard/NewConnectorsWatcher';
import { CloseButton } from '@components';

const ModalPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(6, 'auto'),
  maxWidth: '600px',
}));

export default function RerunInstallationButton() {
  const { token } = useConnectorToken();
  const [open, setOpen] = useState(false);

  if (!token) return null;

  return (
    <>
      <Button variant="contained" size="small" onClick={() => setOpen(true)}>
        Rerun installation command
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Fade in={open}>
          <ModalPaper>
            <Stack direction="column" justifyContent="center" alignItems="stretch" spacing={2}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1">Rerun the local installation command</Typography>
                <CloseButton onClose={() => setOpen(false)} />
              </Stack>
              <LocalInstallInstructions token={token} noTitle />
            </Stack>
          </ModalPaper>
        </Fade>
      </Modal>
    </>
  );
}
